import Breadcrumb from 'components/Breadcrumb';
import Grid, { Container } from 'components/Grid';
import MainLayout from 'components/Layout/Main';
import Paper from 'components/Paper';
import { formatDateString } from 'helpers/legalPage/formatDateString';
import { ROUTE_NAMES } from 'routes';
import routeService from 'services/routes';

import ContentfulDocument from '../legalPages/components/ContentfulDocument/ContentfulDocument';
import LegalPageSeo from '../legalPages/components/LegalPageSeo/LegalPageSeo';
import Navigation from '../legalPages/components/Navigation/Navigation';

import classes from './CommunityGuidelines.module.scss';

const CommunityGuidelines = ({ data, navigationData, appData }) => {
  const currentPath = routeService.generatePath(
    ROUTE_NAMES.COMMUNITY_GUIDELINES
  );
  const breadcrumbItems = [
    {
      name: 'Community Guidelines',
      path: currentPath,
    },
  ];
  const contentfulData = data.content;
  const navigation = Object.values(navigationData);

  return (
    <>
      <LegalPageSeo
        title="Community Guidelines | GetApp"
        data={data}
        routeName={ROUTE_NAMES.COMMUNITY_GUIDELINES}
        url={appData.url}
      />
      <br></br>
      <Breadcrumb structuredDataItems={breadcrumbItems}>
        <Breadcrumb.Item action="go-to_resource_homepage" isDisabled={true}>
          Community Guidelines
        </Breadcrumb.Item>
      </Breadcrumb>
      <Container className={classes.container}>
        <h1 className={classes.homepageHeadline}>GetApp {data.title}</h1>
        <Grid container={true} spacing={3} className={classes.mainSection}>
          <Grid item={true} xs={12} sm={3}>
            <Paper className={classes.card}>
              <Navigation
                className={classes.sidebar}
                currentPath={currentPath}
                navigation={navigation}
              />
            </Paper>
          </Grid>
          <Grid item={true} xs={12} sm={9}>
            <Grid item={true} xs={12} sm={12}>
              <Paper className={classes.card}>
                <div className={classes.content}>
                  <ContentfulDocument
                    content={contentfulData.json}
                    links={data.content.links}
                  />
                  <p>
                    <br /> Policy Last Updated:{' '}
                    <b>{formatDateString(data.updated)}</b>
                  </p>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

CommunityGuidelines.Layout = MainLayout;

export default CommunityGuidelines;
